import _ from 'lodash';
import React, { Component } from 'react';

import request from 'redux/actions/authAPI';

import { 
  CardElement,
  injectStripe
} from 'react-stripe-elements';

import './StripeCard.css';


export class StripeCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      processing: false,
      errorMsg: false
    }

    _.bindAll(this, ['setUpCard']);
  }

  setUpCard() {
    this.setState({processing: true});

    this.props.stripe.createToken()
      .then((r) => {
        if (r.error) {
          this.setState({errorMsg: r.error.message});
        } else {
          this.clear();
          return r.token.id;
        }
      })
      .then((token) => {
        return this.props.dispatch(request({
          url: '/v1/stripe_customer',
          body: {cc_token: token},
          method: 'post'
        }));
      })
      .then(this.props.methodConfirmed)
      .catch(() => {
        this.setState({
          processing: false,
          errorMsg: 'Card confirming failed. Try Again'
        });
      });
  }

  render() {
    return (
      <div className="c-stripe-card">
        <h1>Set up payment information</h1>
        <div className="card">
          <div className="logo"/>
          <div className="form">
            {
              this.props.msg ?
                <p>{this.props.msg}</p>
                :
                <CardElement
                  onReady={card => { this.clear = card.clear; }}
                  onChange={() => this.setState({errorMsg: false})}
                  hidePostalCode={true}
                  style={{ base: { fontSize: '18px' } }}
                />
            }
          </div>
          {
            this.state.errorMsg ?
              <div className='error'>{this.state.errorMsg}</div>
              : null
          }
        </div>
        <button
          className={`btn btn-next ${(this.state.processing) ? 'disabled' : 'active'}`}
          onClick={this.setUpCard}>{this.state.processing ? 'Processing...' : 'Set up'}
        </button>
      </div>
    );
  }
}

export default injectStripe(StripeCard);



// WEBPACK FOOTER //
// ./src/components/core/steps/payment/StripeCard.js